import { BaseService, RequestType } from "@intech/react-service";

class FichaFinanceira extends BaseService {
  constructor() {
    super("fichaFinanceira");
  }

  BuscarUltimaExibicaoPorPlano = (cdPlano: string) =>
    this.CreateRequest<any>(RequestType.GET, `BuscarUltimaExibicaoPorPlano/${cdPlano}`);

  SaoFranciscoBuscarSaldoPorPlano = (cdPlano: string) =>
    this.CreateRequest<any>(RequestType.GET, `saoFranciscoSaldoPorPlano/${cdPlano}`);

}

export const FichaFinanceiraService = new FichaFinanceira();
